import { faker } from '@faker-js/faker';

type Organization = {
    id: string;
    email: string;
    name: string;
    externalId: string;
    settings: any;
    photo: string;
};
export const userFixture = {
    id: faker.datatype.uuid(),
    externalId: faker.datatype.number({ min: 10000, max: 99999 }).toString(),
    firstName: faker.name.firstName(),
    lastName: faker.name.lastName(),
    locale: null,
    email: faker.internet.email(),
    organizations: [] as Organization[],
    currentOrganization: '',
    apiKey: faker.datatype.uuid(),
    personalApiKey: faker.datatype.uuid(),
    permissions: [
        'organizations.read',
        'organizations.users.create',
        'users.update',
        'organizations.invites.read',
        'organizations.invites.create',
        'users.read',
        'users.delete',
        'organizations.users.update',
        'organizations.users.delete',
        'organizations.users.read',
        'organizations.invites.delete',
        'admin',
    ],
    applications: ['mindy'],
    applicationModules: [],
    typology: 'USER',
    roles: ['user_default_role', 'admin'],
};
// Crear la organización relacionada
const organization: Organization = {
    id: faker.datatype.uuid(),
    email: userFixture.email,
    name: `${faker.company.name()}`,
    externalId: userFixture.externalId,
    settings: {},
    photo: 'https://test.quadminds.com/img/logo_qm_flash_blanco.png',
};

// Asignar organización al usuario
userFixture.organizations.push(organization as Organization);
userFixture.organizations.push(organization as Organization);
userFixture.currentOrganization = organization.id;

const randomBase64 = () => Buffer.from(faker.lorem.words(10)).toString('base64url');

export const getRefreshTokenResponse = () => `${randomBase64()}.${randomBase64()}.${randomBase64()}`;
